var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.5 6a5.5 5.5 0 1 1 11 0v2h2a2.5 2.5 0 0 1 2.5 2.5v10a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 2 20.5v-10A2.5 2.5 0 0 1 4.5 8h2zm10 0v2h-9V6a4.5 4.5 0 0 1 9 0m-12 3h15a1.5 1.5 0 0 1 1.5 1.5v10a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 20.5v-10A1.5 1.5 0 0 1 4.5 9m8 3.5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z",
    clipRule: "evenodd"
  })));
});
const SvgLock = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLock);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjUgNkM2LjUgMi45NjI0MyA4Ljk2MjQzIDAuNSAxMiAwLjVDMTUuMDM3NiAwLjUgMTcuNSAyLjk2MjQzIDE3LjUgNlY4SDE5LjVDMjAuODgwNyA4IDIyIDkuMTE5MjkgMjIgMTAuNVYyMC41QzIyIDIxLjg4MDcgMjAuODgwNyAyMyAxOS41IDIzSDQuNUMzLjExOTI5IDIzIDIgMjEuODgwNyAyIDIwLjVWMTAuNUMyIDkuMTE5MjkgMy4xMTkyOSA4IDQuNSA4SDYuNVY2Wk0xNi41IDZWOEg3LjVWNkM3LjUgMy41MTQ3MiA5LjUxNDcyIDEuNSAxMiAxLjVDMTQuNDg1MyAxLjUgMTYuNSAzLjUxNDcyIDE2LjUgNlpNNC41IDlIN0gxN0gxOS41QzIwLjMyODQgOSAyMSA5LjY3MTU3IDIxIDEwLjVWMjAuNUMyMSAyMS4zMjg0IDIwLjMyODQgMjIgMTkuNSAyMkg0LjVDMy42NzE1NyAyMiAzIDIxLjMyODQgMyAyMC41VjEwLjVDMyA5LjY3MTU3IDMuNjcxNTcgOSA0LjUgOVpNMTIuNSAxMi41QzEyLjUgMTIuMjIzOSAxMi4yNzYxIDEyIDEyIDEyQzExLjcyMzkgMTIgMTEuNSAxMi4yMjM5IDExLjUgMTIuNVYxOC41QzExLjUgMTguNzc2MSAxMS43MjM5IDE5IDEyIDE5QzEyLjI3NjEgMTkgMTIuNSAxOC43NzYxIDEyLjUgMTguNVYxMi41WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";